import React from 'react';

import ExecutionStatus from 'src/components/ExecutionStatus';
import { ValueWithLabel } from 'src/components/Utils';
import { AsyncState, Model } from 'src/store/types';

export const MPNExecutionCell = ({ model }: { model: Model }) => {
  return (
    <ValueWithLabel label="Status">
      {' '}
      <ExecutionStatus model={model} refetch={model?.status !== AsyncState.OK && model?.status !== AsyncState.ERROR} />
    </ValueWithLabel>
  );
};
